// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout_table[data-v-3cd6d984]{height:100%;box-sizing:border-box;display:flex;flex-direction:column}.layout_table .header[data-v-3cd6d984]{padding:20px}.layout_table .main[data-v-3cd6d984]{flex:1;padding:0 10px 0 20px;height:400px}.layout_table .footer[data-v-3cd6d984]{padding:20px;text-align:right}", ""]);
// Exports
module.exports = exports;
